var getData = require('callback!./data.js');
// var filters = require('./filters.js');
// var filterTemplate = require('./filter.handlebars');

var markerSvgContent = require('./marker.svg');

function getMarkerSvgContent(map) {
	return markerSvgContent;
}

var worldMapElem = document.getElementById('map--world');
if (worldMapElem) {
	require.ensure(['zebra-map'], function (require) {
		var ZebraMap = require('zebra-map');
		require.ensure(['./world/config.json', './world/map.svg', './world/projection.js'], function (require) {
			const config = require('./world/config.json');
			const svg = require('./world/map.svg');
			const projection = require('./world/projection.js')(config.size.width, config.size.height);

			const map = new ZebraMap('map--world', getData(), config, svg, getMarkerSvgContent, projection);
		});
	});
}

var russiaMapElem = document.getElementById('map--russia');
if (russiaMapElem) {
	require.ensure(['zebra-map'], function (require) {
		var ZebraMap = require('zebra-map');
		require.ensure(['./russia/config.json', './russia/map.svg', './russia/projection.js'], function (require) {
			const config = require('./russia/config.json');
			const svg = require('./russia/map.svg');
			const projection = require('./russia/projection.js')(config.size.width, config.size.height);

			const map = new ZebraMap('map--russia', getData(), config, svg, getMarkerSvgContent, projection);
		});
	});
}



/** WEBPACK FOOTER **
 ** ./frontend/components/map/map.js
 **/